import { useState } from 'react';

export default function InviteStepBody() {
  const [copied, setCopied] = useState(false);

  const emailTemplate = "We're using Tidy Go Links now — type go/vacation in Chrome to request PTO, go/okrs for our OKRs. Sign up at tidygolinks.com with your work email to see all our shortcuts and create your own.";

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(emailTemplate);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="bg-surface"
      style={{
        border: '1px solid var(--color-hairline)',
        borderRadius: 20,
        padding: 20,
        maxWidth: 600,
      }}
    >
      <div className="font-semibold text-ink mb-2.5" style={{ fontSize: 13 }}>
        Send via email
      </div>
      <div
        className="bg-color-bg-alt rounded-lg p-3 mb-3"
        style={{
          fontSize: 12,
          lineHeight: 1.5,
          color: 'var(--color-ink)',
          fontFamily: 'monospace',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        }}
      >
        {emailTemplate}
      </div>
      <button
        onClick={handleCopyEmail}
        className="w-full cursor-pointer font-semibold text-center transition-colors duration-150"
        style={{
          padding: '8px 12px',
          background: copied ? 'var(--accent-solid)' : 'var(--accent-tint)',
          color: copied ? '#fff' : 'var(--accent-deep)',
          border: 'none',
          borderRadius: 8,
          fontSize: 12,
        }}
      >
        {copied ? 'Copied!' : 'Copy to clipboard'}
      </button>
      <div className="text-ink-muted mt-2" style={{ fontSize: 11 }}>
        Paste this into an email to send your team a direct invite.
      </div>
    </div>
  );
}
